module.exports = __webpack_public_path__ + "static/media/hero-1.752b5e4d.jpg";